export const initValues = {
  isPhoneValidating: false,
  messageOnPause: false,
  textMessagePause: '',
  providerConnect: '',
  keyApiProvider: '',
};

export const labelsGlobalSet = {
  '1': 'Група Azure ролі "Менеджер" (ARM_MANAGER)',
  '5': 'Група Azure ролі "Суперюзер" (ARM_SUPERUSER)',
};

export const GET_GLOBAL_SETTINGS_REQUEST = 'GET_GLOBAL_SETTINGS_REQUEST' as const;
export const GET_GLOBAL_SETTINGS_SUCCESS = 'GET_GLOBAL_SETTINGS_SUCCESS' as const;
export const GET_GLOBAL_SETTINGS_ERROR = 'GET_GLOBAL_SETTINGS_ERROR' as const;

export const PUT_GLOBAL_SETTINGS_REQUEST = 'PUT_GLOBAL_SETTINGS_REQUEST' as const;
export const PUT_GLOBAL_SETTINGS_SUCCESS = 'PUT_GLOBAL_SETTINGS_SUCCESS' as const;
export const PUT_GLOBAL_SETTINGS_ERROR = 'PUT_GLOBAL_SETTINGS_ERROR' as const;

export const FORCE_SAVE_GLOBAL_SET = 'FORCE_SAVE_GLOBAL_SET' as const;
export const SET_SAVE_GLOBAL_SET = 'SET_SAVE_GLOBAL_SET' as const;
